import { Component, h, Prop, Event, EventEmitter, State } from "@stencil/core";
import { Element } from "@stencil/core";

@Component({
  tag: "datagrid-filter-date-range",
  shadow: false,
})
export class DatagridFilterDateRangeLogic {
  @Element() el!: HTMLElement;
  /**
   * The ID of the grid to which this filter belongs.
   * This is used to identify which grid the filter is associated with.
   * It is passed to the filterChanged event when the filter value changes.
   * @example "grid-1"
   * @type {string}
   * @required
   * @description The ID of the grid to which this filter belongs.
   * This is used to identify which grid the filter is associated with.
   * It is passed to the filterChanged event when the filter value changes.
   * @default ""
   */
  @Prop() grid_id!: string;
  /**
   * The field name to which this filter is applied.
   * This is used to identify which field the filter is associated with.
   * It is passed to the filterChanged event when the filter value changes.
   * @example "eligible_year"
   * @type {string}
   * @required
   * @description The field name to which this filter is applied.
   * This is used to identify which field the filter is associated with.
   * It is passed to the filterChanged event when the filter value changes.
   * @default ""
   */
  @Prop() field: string;
  /**
   * The label to be displayed for this filter.
   * This is used to identify the filter in the UI.
   * @example "Eligible Year"
   * @type {string}
   * @required
   * @description The label to be displayed for this filter.
   * This is used to identify the filter in the UI.
   * @default ""
   */
  @Prop() label!: string;
  /**
   * The options to be displayed in the filter.
   * This is a JSON string that contains an array of objects with label and value properties.
   * @example '[{"label": "2021", "value": "2021"}, {"label": "2022", "value": "2022"}]'
   */
  @Prop() initialValue?: string;
  /**
   * The type of the filter.
   * This is used to identify the type of filter in the UI.
   */
  @Prop() type: string;

  @Event() filterChanged: EventEmitter<{
    grid_id: string;
    field: string;
    value: { startDate: string; endDate: string };
    type: string;
  }>;

  @State() selectedFilters: { startDate: string; endDate: string } = {
    startDate: null,
    endDate: null,
  };

  handleDateRangeChange(event: CustomEvent) {
    const { startDate, endDate } = event.detail;

    this.selectedFilters = {
      startDate,
      endDate,
    };

    this.emitFilterChange();

    // Vue 2: emit 'input' event
    this.el.dispatchEvent(new CustomEvent('input', {
      bubbles: true,
      composed: true,
      detail: this.selectedFilters,
    }));

    // Vue 3: emit 'update:modelValue' event
    this.el.dispatchEvent(new CustomEvent('update:modelValue', {
      bubbles: true,
      composed: true,
      detail: this.selectedFilters,
    }));
  }

  emitFilterChange() {
    const selectedValue = this.selectedFilters;

    this.filterChanged.emit({
      grid_id: this.grid_id,
      field: this.field,
      value: selectedValue,
      type: "datagrid-filter-date-range",
    });
  }

  render() {
    return (
      <div class="datagrid-filter-date-range">
        <signet-date-range
          startDate={this.selectedFilters.startDate}
          endDate={this.selectedFilters.endDate}
          onChangeEvent={(e) => this.handleDateRangeChange(e)}
        />
      </div>
    );
  }
}
